import { render, staticRenderFns } from "./PushWordpress.vue?vue&type=template&id=d82a7de2&"
import script from "./PushWordpress.vue?vue&type=script&lang=ts&"
export * from "./PushWordpress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports